module.exports = __webpack_public_path__ + "static/media/VN.cb0ea0b4.png";